import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ImageCarousel } from '../../image-carousel/image-carousel.component';
import { sweetsAndDrinks } from '../../../interfaces/sweets-and-drinks';
import { CommonModule } from '@angular/common';
import { TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-sweets-and-drinks',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    CommonModule,
    TranslatePipe
  ],
  templateUrl: './sweets-and-drinks.component.html',
  styleUrl: './sweets-and-drinks.component.scss'
})
export class SweetsAndDrinksComponent {

  constructor(public dialog: MatDialog) { }

  openDialog(castle: sweetsAndDrinks): void {
    this.dialog.open(ImageCarousel, {
      maxHeight: '480px',
      maxWidth: '800px',
      autoFocus: false,
      data: castle
    });
  }

  sweetsAndDrinks: sweetsAndDrinks[] = [
    {
      name: "sweetsAndDrinks.Popcornmaschine",
      size: "0,94m x 0,5m x 0,825m",
      weight: "43,2kg",
      price: "99",
      fraction: "00",
      features: "sweetsAndDrinks.OhneRäder",
      engine: "230V",
      img: ["Popcorn1.png", "Popcorn2.png", "Popcorn3.png"],
      extras: [
        { item: "sweetsAndDrinks.Mais", price: "7", fraction: "90" },
        { item: "sweetsAndDrinks.Popcornöl", price: "9", fraction: "95" },
        { item: "sweetsAndDrinks.Beutel", price: "14", fraction: "95" }
      ],
      cleaningFee: "30"
    },
    {
      name: "sweetsAndDrinks.Zuckerwattemaschine",
      size: "0,95m x 0,52m x 1,26m",
      weight: "28kg",
      price: "99",
      fraction: "00",
      features: "sweetsAndDrinks.ZuckerFarben",
      engine: "230V",
      img: ["Zuckerwatte1.png", "Zuckerwatte2.png", "Zuckerwatte3.png"],
      extras: [
        { item: "sweetsAndDrinks.Aromazucker", price: "11", fraction: "95" },
        { item: "sweetsAndDrinks.Stäbe30", price: "5", fraction: "90" },
        { item: "sweetsAndDrinks.Stäbe40", price: "7", fraction: "90" }
      ],
      cleaningFee: "30"
    },
    {
      name: "sweetsAndDrinks.Slusheismaschine",
      size: "0,52m x 0,21m x 0,80m",
      weight: "33kg",
      price: "99",
      fraction: "00",
      features: "sweetsAndDrinks.SirupSorten",
      engine: "230V",
      img: ["Slusheis1.png"],
      extras: [
        { item: "sweetsAndDrinks.Becher", price: "6", fraction: "90" },
        { item: "sweetsAndDrinks.Löffel", price: "3", fraction: "90" },
        { item: "sweetsAndDrinks.Sirup", price: "9", fraction: "95" }
      ],
      cleaningFee: "30"
    },
    {
      name: "sweetsAndDrinks.SlusheismaschineDouble",
      size: "0,43m × 0,45m × 0,80m",
      weight: "64kg",
      price: "149",
      fraction: "00",
      features: "sweetsAndDrinks.SirupSorten",
      engine: "230V",
      img: ["SlusheisDoppelt.png"],
      extras: [
        { item: "sweetsAndDrinks.Becher", price: "6", fraction: "90" },
        { item: "sweetsAndDrinks.Löffel", price: "3", fraction: "90" },
        { item: "sweetsAndDrinks.Sirup", price: "9", fraction: "95" }
      ],
      cleaningFee: "30"
    }
  ];
}
